<template>
    <AlertModal @close="clearAlert" v-if="data">
        <template v-if="data.type === 'alert'">
            <SvgIcon name='feedback/warning-bold' class="icon-xlarge" />
            <div class="h3 reg">Something went wrong</div>
        </template>
        <template v-if="data.type === 'info'">
            <SvgIcon name='feedback/info' class="icon-xlarge info is-center" />
        </template>
        <template v-if="data.type === 'warning'">
            <SvgIcon name='feedback/warning-outline' class="icon-xlarge" />
            <div class="h3 reg">Warning</div>
        </template>
        <div class="b1 reg">{{ data.message }}</div>
    </AlertModal>
</template>
<script>
import AlertModal from './AlertModal.vue';

export default {
    components: {
        AlertModal,
    },
    props: ['data'],
    emits: ['close'],
    methods: {
        clearAlert() {
            this.$emit('close');
        },
    },
}
</script>
<style scoped>
.info {
    color: var(--notification-colours-correct);
    transform: rotate(180deg);
    transform-origin: center;
}
</style>